export const uploadPreview = (node, file) => {
    const reader = new FileReader();
    reader.onload = (event) => {
        const result = event.target?.result;
        if (typeof result === 'string') {
            node.src = result;
        }
    };
    reader.readAsDataURL(file);
};
